import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-regions',
	templateUrl: './symptom-check-regions.component.html',
	imports: [CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule]
})
export class SymptomCheckRegionsComponent implements OnInit {
	private europeRegionId: string = 'p_15';
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);

	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();

	isEuropeRegion: boolean;
	isProcessing: boolean = false;
	vm: any = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		if (this.vm.params['type'] === 'pre-visit') {
			this.vm.preVisit = true;
		}
		
		var isEuropeRegionOnlySelected = this.vm.interview.evidence.some(evidence =>
			evidence.hasOwnProperty('isEuropeRegionOnlySelected')
		);
		this.vm.isEuropeRegion = isEuropeRegionOnlySelected ? this.checkIfOnlyEuropeRegionSelected() : true;
		
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}

		this.loadScript('https://apps-content.s3-eu-west-1.amazonaws.com/worldmap/mapdata.js', 'wm-mapdata')
			.then(() => {
				if (this.vm.previsitLocation && window['simplemaps_worldmap_mapdata']) {
					window['simplemaps_worldmap_mapdata'].main_settings.background_color = "#26009d";
					window['simplemaps_worldmap_mapdata'].main_settings.state_hover_color = "#26009d";
				}
				return this.loadScript('https://apps-content.s3-eu-west-1.amazonaws.com/worldmap/worldmap.js', 'wm-lib');
			})
			.then(() => {
				return this.loadScript('https://apps-content.s3-eu-west-1.amazonaws.com/worldmap/select.js', 'wm-select');
			}).then(() => {
				if (!this.vm.isEuropeRegion) {
					this.initializeMap();
				}
			})
			.catch(console.error);

		this.vm.handleTravelResponse = this.handleTravelResponse;
		this.vm.isInitialized = true;

		this.vm.handleBack = this.symptomCheckService.prevStep;
		this.vm.handleSubmit = this.handleSubmit;
	}

	private checkIfOnlyEuropeRegionSelected(): boolean {
		return this.interview.evidence.some((evidence: any) => evidence.isEuropeRegionOnlySelected === true);
	}


	loadScript(src, id) {
		if (!src) {
			return this.angularHelperService.getPromise().reject('No src specified');
		}

		if (!id) {
			return this.angularHelperService.getPromise().reject('No id specified');
		}

		if (document.getElementById(id)) {
			console.info('LOAD_SCRIPT: script "' + src + '" is ignored, since it is already loaded');
			return this.angularHelperService.getPromise().resolve();
		}

		var deferred: any = this.angularHelperService.getDeferredPromise();
		var fjs: any = document.getElementsByTagName('script')[0];
		var js: any = document.createElement('script');
		js.id = id;
		js.src = src
		js.onload = () => {
			this.angularHelperService.createTimer(() => {
				deferred.resolve();
			}, 100);
		};
		fjs.parentNode.insertBefore(js, fjs);

		return deferred.promise;
	}

	initializeMap() {
		setTimeout(() => {
			var _window: any = window;
			this.vm.map = _window.simplemaps_worldmap;
			this.vm.select = _window.simplemaps_select;
			if (this.vm.map) {
				this.vm.select.map = this.vm.map;
				this.vm.regions = [];
				this.vm.interview.evidence = this.vm.interview.evidence || [];

				this.vm.map.hooks.click_state = this.handleRegionClick;
				this.vm.map.load();
				this.vm.select.deselect_all();

				if (!this.vm.map.mapdata.state_specific) {
					console.error("Map data is not loaded properly.");
					return;
				}

				Object.keys(this.vm.map.mapdata.state_specific).forEach((key) => {
					var isInEvidence: any = !!this.vm.interview.evidence.filter((evidence) => {
						return evidence.id === this.vm.map.mapdata.state_specific[key].id;
					}).length;

					if (isInEvidence) {
						this.vm.regions.push(key);
						this.vm.select.select(key);
					}
				});

			} else {
				console.error('Worldmap not initialized');
				return;
			}
		}, 70);
	}

	handleRegionClick = (region: any): void => {
		var index: any = this.vm.regions.indexOf(region);
		var regionId: any = this.vm.map.mapdata.state_specific[region].id;
		var isSelected: any = index === -1;
		var interview: any = this.symptomCheckService.getInterviewResetTo(5);

		if (isSelected) {
			this.vm.regions.push(region);
			var isInEvidence: any = !!interview.evidence.filter((evidence) => { return evidence.id === regionId; }).length;
			if (!isInEvidence) {
				interview.evidence.push({
					choice_id: 'present',
					id: regionId,
					addedAtStep: 5,
					source: 'predefined',
					isEuropeRegionOnlySelected: false
				});
			}
		} else {
			this.vm.regions.splice(index, 1);
			interview.evidence = interview.evidence.filter((evidence) => { return evidence.id !== regionId; });
		}

		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}

	saveRegionToInterview(regionId: string) {
		const interview = this.symptomCheckService.getInterviewResetTo(5);
		const isInEvidence = interview.evidence.some((evidence: any) => evidence.id === regionId);

		if (!isInEvidence) {
			interview.evidence.push({
				choice_id: 'present',
				id: regionId,
				addedAtStep: 5,
				source: 'predefined',
				isEuropeRegionOnlySelected: true
			});
		}

		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}

	handleSubmit() {
		this.vm.submitted = true;
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;

		if (!this.vm.interview.sessionId) {
			this.vm.interview.sessionId = 'create';
			this.vm.interview.stepId = 0;
		}

		if (this.vm.preVisit) {
			this.vm.interview.preVisit = true;
		}

		this.restService.saveDiagnosis(this.vm.interview)
			.then((res) => {
				if (!res.interview) return;
				var interview: any = this.angularHelperService.copy(this.vm.interview);
				interview.sessionId = res.interview.sessionId;
				interview.localId = res.interview.localId;
				interview.sex = res.interview.sex;
				interview.age = res.interview.age;
				interview.diagnosis = res;

				this.vm.interview = interview;
				this.interviewChange.emit(this.vm.interview);

				if (interview.diagnosis.should_stop) {
					this.vm.interview = interview;
					this.interviewChange.emit(this.vm.interview);
					this.angularHelperService.createTimer(() => { this.symptomCheckService.nextStep(1); });
					return;
				}

				this.angularHelperService.createTimer(() => {
					this.symptomCheckService.nextStep();
				});
			})
			.catch(console.error);
	}

	handleTravelResponse(answer) {
		this.vm.isEuropeRegion = answer === 'no';
		console.log(this.vm.isEuropeRegion);
		if (this.vm.isEuropeRegion) {
			this.removeAllRegionsFromInterview();
			this.saveRegionToInterview(this.vm.europeRegionId);
		} else {
			this.removeRegionFromInterview(this.europeRegionId);
			this.vm.regions = [];
			this.initializeMap();
		}
	}

	removeRegionFromInterview(regionId: string): void {
		const interview: any = this.symptomCheckService.getInterviewResetTo(5);

		interview.evidence = interview.evidence.filter((evidence) => evidence.id !== regionId);

		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}

	removeAllRegionsFromInterview() {
		const interview: any = this.symptomCheckService.getInterviewResetTo(5);
		interview.evidence = interview.evidence.filter(evidence => evidence.addedAtStep !== 5);

		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}

}